import React from "react";
import "./styles.css";
import {
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@material-ui/core";
import { LOAN_TYPES, PROPERTY_ASSET_TYPES } from "@loanbossinc/component-library";
import { loanTypeList } from "constants/loanTypes";
import { propertyAssetTypesList } from "constants/propertyAssetTypes";

// TODO: Need to drive this from the Database
const loanProceedsRunTableLoanTypes = loanTypeList
  .filter(lt => lt.value === LOAN_TYPES.BALANCE_SHEET ||
    lt.value === LOAN_TYPES.FREDDIE_MAC ||
    lt.value === LOAN_TYPES.FANNIE_MAE ||
    lt.value === LOAN_TYPES.HUD ||
    lt.value === LOAN_TYPES.CMBS ||
    lt.value === LOAN_TYPES.LIFE_CO ||
    lt.value === 10 ||
    lt.value === LOAN_TYPES.OTHER_TYPE)
  .map(lt => ({
    name: lt.name.toUpperCase(),
    loanType: lt.value
  }));

const loanProceedsRunTablePropertyTypes = propertyAssetTypesList
  .filter(pt => pt.value === PROPERTY_ASSET_TYPES.CONDO ||
    pt.value === PROPERTY_ASSET_TYPES.DATA_CENTER ||
    pt.value === PROPERTY_ASSET_TYPES.FLEX ||
    pt.value === PROPERTY_ASSET_TYPES.HOTEL ||
    pt.value === PROPERTY_ASSET_TYPES.INDUSTRIAL ||
    pt.value === PROPERTY_ASSET_TYPES.LAND ||
    pt.value === PROPERTY_ASSET_TYPES.MEDICAL ||
    pt.value === PROPERTY_ASSET_TYPES.MIXED_USE ||
    pt.value === PROPERTY_ASSET_TYPES.MULTIFAMILY ||
    pt.value === PROPERTY_ASSET_TYPES.OFFICE ||
    pt.value === PROPERTY_ASSET_TYPES.OTHER ||
    pt.value === PROPERTY_ASSET_TYPES.RESIDENTIAL ||
    pt.value === PROPERTY_ASSET_TYPES.RETAIL ||
    pt.value === PROPERTY_ASSET_TYPES.SENIOR_LIVING ||
    pt.value === PROPERTY_ASSET_TYPES.STUDENT_HOUSING)
  .map(pt => ({
    name: pt.name,
    propertyType: pt.value
  }));

const RunTable = ({ onCheck, checkedItems }) => (
  <div className="run-table-wrapper">
    <Table>
      <TableHead>
        <TableRow className="run-table-table-header-row">
          <TableCell className="run-table-table-header-property-type-cell">Property Type</TableCell>
          {loanProceedsRunTableLoanTypes.map((lt, idx) => <TableCell key={idx} loanType={lt.loanType} className="run-table-table-header-cell">{lt.name}</TableCell>)}
        </TableRow>
      </TableHead>
      <TableBody>
        {
          loanProceedsRunTablePropertyTypes.map((pt, idx) => <TableRow key={idx} className="run-table-table-body-row">
            <TableCell className="run-table-table-body-cell">{pt.name}</TableCell>
            {loanProceedsRunTableLoanTypes.map((lt, i) => <TableCell
              key={i}
              loanType={lt.loanType}
              propertyType={pt.propertyType}
              className="run-table-table-body-cell"
            >
              <Checkbox
                checked={checkedItems.includes(`${`${pt.propertyType}#${lt.loanType}`}`)}
                onChange={() => {
                  onCheck(pt, lt);
                }}
              />
            </TableCell>)}
          </TableRow>)
        }
      </TableBody>
    </Table>
  </div>
);

export default RunTable;
